import React, {
  createContext,
  ReactNode,
  useContext,
  useMemo,
  useState,
} from 'react';
import { useSearchParams } from 'react-router-dom';

interface DebugModeContextType {
  isDebugMode: boolean;
}

const DebugModeContext = createContext<DebugModeContextType>({
  isDebugMode: false,
});

export const useDebugMode = () => useContext(DebugModeContext);

const DebugModeProvider = ({ children }: { children: ReactNode }) => {
  const [searchParams] = useSearchParams();
  const [isDebugMode] = useState(() => searchParams.get('debug') === 'true');

  const value = useMemo(() => ({ isDebugMode }), [isDebugMode]);

  return (
    <DebugModeContext.Provider value={value}>
      {children}
    </DebugModeContext.Provider>
  );
};

export default DebugModeProvider;
